import axios from 'axios';
import { useFormik } from 'formik';
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup'
import { paths } from '../../utils/routes';
import { Helmet } from 'react-helmet'


export default function VerifyResetCode() {
  <Helmet>
    <meta charSet="utf-8" />
    <title>Verify Reset Code</title>
  </Helmet>

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('');
  const navigator = useNavigate()
  const initialValues = {
    resetCode: '',
  }

  const verifyResetCode = async (data) => {
    try {
      setIsLoading(true)
      const response = await axios.post("https://ecommerce.routemisr.com/api/v1/auth/verifyResetCode", { ...data })
      localStorage.setItem('resetCode', data.resetCode)
      navigator(`${paths.resetPassword}`)
      setIsLoading(false)

    } catch (error) {
      setError(error.response.data.message)
      setIsLoading(false)

    }
  }


  const validationSchema = Yup.object({
    resetCode: Yup.string().matches(/^[0-9]+$/, "Must be only digits").required('resetCode is Required').min(6, 'Must be exactly 6 digits').max(6, 'Must be exactly 6 digits'),
  })
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: verifyResetCode
  })
  return <>
    <div className="w-75 m-auto p-3">
      <h3 className='my-3'>Reset Password</h3>
      {error && <p className='alert alert-danger'>{error}</p>}
      <form onSubmit={formik.handleSubmit}>
        <label htmlFor="resetCode">resetCode</label>
        <input type="resetCode" name="resetCode" id="resetCode" className='form-control my-2' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.errors.resetCode && formik.touched.resetCode && <p className='alert alert-danger'> {formik.errors.resetCode}</p>}

        <button type='submit' className='bg-main btn text-white mt-2' disabled={!(formik.errors && formik.dirty)}>{isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Verify '}</button>
      </form>
    </div>
  </>
}